import React from 'react';

interface RotationSelectorProps {
  rotation: number;
  setRotation: (rotation: number) => void;
}

const RotationSelector: React.FC<RotationSelectorProps> = ({ 
  rotation = 0, 
  setRotation,
}) => {
  return (
    <div className="space-y-4">
      <div className="form-control">
        <label className="label">
          <span className="label-text">Fretboard Rotation:</span>
          <span className="label-text-alt">{rotation}</span>
        </label>
        <input
          type="range"
          min="-90"
          max={90}
          value={rotation}
          className="range"
          step="10"
          onChange={(e) => setRotation(parseInt(e.target.value))}
        />
        <div className="w-full flex justify-between text-xs px-2">
          <span>-90</span>
          <span>90</span>
        </div>
      </div>
    </div>
  );
};

export default RotationSelector;